import React from "react";
import { humanize } from "underscore.string";

type NameColumnProps = {
  name: string;
  readOnly: boolean;
};

export const NameColumn = ({ name, readOnly }: NameColumnProps): JSX.Element => (
  <div style={readOnly ? { opacity: 0.5, cursor: "default" } : undefined}>{humanize(name)}</div>
);
